import React from 'react';
import { Box, Text, TextArea } from 'grommet';
import styled from 'styled-components';
import clipArt from './clipart.png';
const HeadingText = styled(Text)`
  font: normal normal bold 32px/40px Muli;
  letter-spacing: 0.88px;
`;
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      msg: ''
    };
  }
  static getDerivedStateFromError(error) {
    console.log('Hollaaa', error);
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    this.setState({
      msg: `${error.message} ${errorInfo.componentStack}`
    });
    console.log({
      error,
      errorInfo
    });
  }
  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/React.createElement(Box, {
        flex: {
          grow: 1
        },
        margin: "medium",
        pad: {
          horizontal: 'small',
          vertical: 'xsmall'
        }
      }, /*#__PURE__*/React.createElement(Box, {
        direction: "row",
        justify: "start",
        background: {
          image: `url(${clipArt})`
        },
        height: "100vh",
        width: "100%",
        id: "home"
      }, /*#__PURE__*/React.createElement(Box, {
        pad: {
          top: '2rem',
          left: '6rem'
        },
        width: "53%"
      }, /*#__PURE__*/React.createElement(HeadingText, null, "Ooops !!!,"), /*#__PURE__*/React.createElement(HeadingText, null, "Even the things we love break sometimes,"), /*#__PURE__*/React.createElement(Text, {
        size: "17px",
        margin: {
          vertical: 'medium'
        }
      }, "Thanks for your patience while we put the pieces back together."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Text, {
        size: "17px"
      }, "In the meantime, if you meet our developer, pass this note..."), /*#__PURE__*/React.createElement(TextArea, {
        value: this.state.msg,
        resize: false
      }))));
    }
    return this.props.children;
  }
}
export default ErrorBoundary;